<template>
  <div
    v-bind="$attrs"
    class="mx-2">
    <v-tooltip v-bind="$attrs">
      <template #activator="{ on, attrs }">
        <v-btn
          :style="styles"
          elevation="0"
          fab
          :color="color"
          dark
          x-small
          v-bind="attrs"
          :to="to"
          v-on="on"
          @click="submitBtn()"
        >
          <v-icon>
            {{ icon }}
          </v-icon>
        </v-btn>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </div>
</template>
<script>

export default {
  props: {
    color: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: ''
    },
    styles: {
      type: String,
      default: ''
    },
    to: {
      type: [String, Object],
      default: null
    }
  },
  data () {
    return {

    }
  },
  methods: {
    submitBtn () {
      this.$emit('submitBtn')
    }
  }

}
</script>
<style scoped>

</style>
